type PassengerPrice = {
  Code?: string;
  DisplayPricePerPassenger?: number | string;
  FullPricePerPassenger?: number | string;
};

type SpecialOfferFlight = {
  AlternativeCurrencyPricingDetails?: {
    AlternativeCurrencyPricingDetail?: Array<{
      FlightPricing?: {
        FlightPassengerPrices?: {
          FlightPassengerPrice?: PassengerPrice | PassengerPrice[];
        };
        FlightPrice?: {
          FullPrice?: number | string;
        };
      };
    }>;
  };
  FlightPassengerPrices?: {
    FlightPassengerPrice?: PassengerPrice | PassengerPrice[];
  };
  FlightPrice?: {
    FullPrice?: number | string;
  };
  PricingDetails?: {
    PricingDetail?: Array<{
      FlightPricing?: {
        FlightPassengerPrices?: {
          FlightPassengerPrice?: PassengerPrice | PassengerPrice[];
        };
        FlightPrice?: {
          FullPrice?: number | string;
        };
      };
    }>;
  };
};

const getFlightPricing = (
  flight?: SpecialOfferFlight | null,
  preferAlternativeCurrency = false
) =>
  (preferAlternativeCurrency
    ? flight?.AlternativeCurrencyPricingDetails
        ?.AlternativeCurrencyPricingDetail?.[0]?.FlightPricing
    : null) ||
  flight?.PricingDetails?.PricingDetail?.[0]?.FlightPricing ||
  flight;

export const getFlightPassengerPrices = (
  flight?: SpecialOfferFlight | null,
  preferAlternativeCurrency = false
): PassengerPrice[] => {
  const passengerPrices = getFlightPricing(flight, preferAlternativeCurrency)
    ?.FlightPassengerPrices?.FlightPassengerPrice;

  if (Array.isArray(passengerPrices)) {
    return passengerPrices;
  }

  return passengerPrices ? [passengerPrices] : [];
};

export const getFlightPassengerCount = (
  flight?: SpecialOfferFlight | null,
  preferAlternativeCurrency = false
): number => {
  const passengerPrices = getFlightPassengerPrices(
    flight,
    preferAlternativeCurrency
  );

  return passengerPrices.length || 1;
};

export const getFlightPricePerPassenger = (
  flight?: SpecialOfferFlight | null,
  preferAlternativeCurrency = false
): number | string | undefined => {
  const flightPricing = getFlightPricing(flight, preferAlternativeCurrency);
  const passengerPrices = getFlightPassengerPrices(
    flight,
    preferAlternativeCurrency
  );
  const firstPayingPassengerPrice =
    passengerPrices.find((passengerPrice) => passengerPrice.Code !== "INF") ||
    passengerPrices[0];

  if (firstPayingPassengerPrice) {
    const passengerPrice =
      firstPayingPassengerPrice.DisplayPricePerPassenger ||
      firstPayingPassengerPrice.FullPricePerPassenger;

    if (passengerPrice) {
      return passengerPrice;
    }
  }

  if (flightPricing?.FlightPrice?.FullPrice && passengerPrices.length > 1) {
    return (
      Number(flightPricing.FlightPrice.FullPrice) / passengerPrices.length
    ).toFixed(2);
  }

  return flightPricing?.FlightPrice?.FullPrice;
};

export const getFlightTotalPrice = (
  flight?: SpecialOfferFlight | null,
  preferAlternativeCurrency = false
): number | string | undefined =>
  getFlightPricing(flight, preferAlternativeCurrency)?.FlightPrice?.FullPrice;
